import { makeStyles } from '@material-ui/core'

export default makeStyles(() => ({
    ul: {
        marginTop: '7px',
        padding: '7px',
        justifyContent: 'space-around',
    }
}))